// 场站详情--基础信息
import React, { PureComponent } from "react";
import { Modal, Spin, message } from "antd";
// import PropTypes from "prop-types";
// 国际化切换语言
// import { connect } from 'react-redux';
import { injectIntl } from "react-intl";
import { EditOutlined } from "@ant-design/icons";
import fetchHandler from "@/fetch/fetchHandler";
import { electricalLossUpdate, getStubGroupDetail } from "@/fetch/fetchApi";
// 组件引用
import ChargeOrder3Day from "./chargeOrder3Day";
import DbmHistory from "./dbmHistory";
import ElectricalLossEdit from "./electricalLossEdit";

const timeTypeMap = new Map([
  [1, "峰"],
  [2, "尖"],
  [3, "谷"],
  [4, "平"],
]);

class StubGroupDetailInfo extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubGroupDetailInfo;
    this.state = {
      result: {},
      seeframeWorkVisible: false,
      edited: false,
    };
    this.query = {};
    this.layout = [
      "inline", // 横向布局
      "horizontal", // 纵向布局
    ];
  }

  componentWillMount() {
    this.getStubDetail();
  }

  // 获取场站详情
  getStubDetail() {
    const fettchApi = getStubGroupDetail;
    fetchHandler(fettchApi, {
      stubGroupId: this.props.stubId,
    }).then((res) => {
      if (res && (res.code === "ok" || res.code === "success")) {
        // 把支持的企业组合下
        let result = this.props.isWare ? res.data[0] : res.data;
        if (result == null) {
          result = {};
        }
        if (result.companyList && result.companyList != null) {
          result.companyList = result.companyList.join(",");
        }
        this.setState({
          result: result,
          stubSpinning: false,
        });
      }
    });
  }

  formatterPrice = (data) => {
    if (!data || data.length === 0) {
      return "--";
    }

    const results = [];
    data.forEach((v) => {
      results.push(
        <div>
          <div>
            {`${timeTypeMap.get(v.timeType) || ""} ${v.startTime}~${v.endTime} 电价：${(
              v.totalPrice || 0
            ).toFixed(4)}`}
          </div>
          <div style={{ fontSize: 14, color: "#777" }}>
            {` (基础电价：${(v.basePrice || 0).toFixed(4)} 电损电价：${(v.lossPrice || 0).toFixed(
              4,
            )} 保利电价：${(v.profitPrice || 0).toFixed(4)} 服务费：${(v.servicePrice || 0).toFixed(
              4,
            )})`}
          </div>
        </div>,
      );
    });
    return results;
  };

  handleStubStatusLogClick = () => {
    this.stubIdData = this.state.result.key;
    this.modalVisibleAction("seeDetailVisible", true);
    this.setState({
      seeDetailVisible: true,
    });
  };

  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  // 固件升级记录按钮点击
  handleStubframeWorkClick = () => {
    this.stubIdData = this.props.stubId;
    this.modalVisibleAction("seeframeWorkVisible", true);
    this.setState({
      seeframeWorkVisible: true,
    });
  };

  // 信号强度历史记录
  handleDbmHistoryClick = () => {
    this.stubIdData = this.props.stubId;
    this.modalVisibleAction("dbmHistoryVisible", true);
  };

  // 电损修改
  handleSubmitElEdit = () => {
    const values = this.elRef.handleSubmit();

    fetchHandler(electricalLossUpdate, {
      ...values,
      stubId: this.props.stubId,
    }).then((res) => {
      if (res && res.code === "success") {
        message.success("修改成功");
        // 刷新详细信息
        this.getStubDetail();

        this.setState({
          edited: false,
          // result: {
          //     ...this.state.result,
          //     ...values
          // }
        });
      }
    });
  };

  render() {
    return (
      <Spin spinning={this.state.stubSpinning}>
        <div className="sc-modal-scroll">
          <div className="page-panel" style={{ padding: "0 24px 24px 24px" }}>
            <div className="page-info-item">
              <h3>
                <span>{this.internationalization.title1}：</span>
              </h3>
              <ul>
                <li className="stationName">
                  <strong>{this.internationalization.title2}：</strong>
                  <span>{this.state.result.stubGroupId}</span>
                </li>
                <li className="stationName">
                  <strong>{this.internationalization.projectOrder}：</strong>
                  <span>{this.state.result.projectNumber}</span>
                </li>
                <li className="stationName">
                  <strong>{this.internationalization.title3}：</strong>
                  <span>{this.state.result.name ? this.state.result.name : "--"}</span>
                </li>

                <li className="stationName">
                  <strong>{this.internationalization.title4}：</strong>
                  <span>{this.state.result.cityName ? this.state.result.cityName : "--"}</span>
                </li>
                <li className="stationName">
                  <strong>{this.internationalization.title5}：</strong>
                  <span>{this.state.result.address ? this.state.result.address : "--"}</span>
                </li>

                <li className="stationName">
                  <strong>{this.internationalization.title9}：</strong>
                  {/* <span>

                  {
                      this.state.result.operationType === 0 ? this.internationalization.operationType1 : ""
                    }
                    {
                      this.state.result.operationType === 1 ? this.internationalization.operationType2 : ""
                    }
                    {
                      this.state.result.operationType === 2 ? this.internationalization.operationType3 : ""
                    }
                    {
                      this.state.result.operationType === 3 ? this.internationalization.operationType4 : ""
                    }
                    {
                      (this.state.result.operationType !== 0 && this.state.result.operationType !== 1 && this.state.result.operationType !== 2 && this.state.result.operationType !== 3) ? this.internationalization.title8 : ""
                    }
                  </span> */}
                  <span>
                    {this.state.result.type === 0 ? this.internationalization.title6 : ""}
                    {this.state.result.type === 1 ? this.internationalization.title7 : ""}
                    {this.state.result.type !== 0 && this.state.result.type !== 1
                      ? this.internationalization.title8
                      : ""}
                  </span>
                </li>

                <li className="stationName">
                  <strong>{this.internationalization.title10}：</strong>
                  <span>
                    {this.state.result.stubGroupType === 0
                      ? this.internationalization.stubGroupType1
                      : ""}
                    {this.state.result.stubGroupType === 1
                      ? this.internationalization.stubGroupType2
                      : ""}
                    {this.state.result.stubGroupType === 2
                      ? this.internationalization.stubGroupType3
                      : ""}
                    {this.state.result.stubGroupType === 3
                      ? this.internationalization.stubGroupType4
                      : ""}
                    {this.state.result.stubGroupType !== 0 &&
                    this.state.result.stubGroupType !== 1 &&
                    this.state.result.stubGroupType !== 2 &&
                    this.state.result.stubGroupType !== 3
                      ? this.internationalization.title8
                      : ""}
                  </span>
                </li>

                {/* <li className="stationName">
                  <strong>{this.internationalization.title12}：</strong>
                  <span>
                    {
                      this.state.result.type === 0 ? this.internationalization.title6 : ""
                    }
                    {
                      this.state.result.type === 1 ? this.internationalization.title7 : ""
                    }
                    {
                      (this.state.result.type !== 0 && this.state.result.type !== 1) ? this.internationalization.title8 : ""
                    }

                  </span>
                </li> */}

                <li className="stationName">
                  <strong>{this.internationalization.title24}：</strong>
                  <span>
                    {this.state.result.serviceTime ? this.state.result.serviceTime : "--"}
                  </span>
                </li>
                <li className="stationName">
                  <strong>{this.internationalization.title25}：</strong>
                  <span>{this.state.result.hasGun === "0" ? "否" : "是"}</span>
                </li>
                <li className="stationName">
                  <strong>{this.internationalization.title26}：</strong>
                  <span>
                    {this.state.result.stubGroupInfo ? this.state.result.stubGroupInfo : "--"}
                  </span>
                </li>

                <li className="stationName">
                  <strong>{this.internationalization.title27}：</strong>
                  <span>
                    {this.state.result.parkingInfo ? this.state.result.parkingInfo : "--"}
                  </span>
                </li>

                <li className="stationName">
                  <strong>{this.internationalization.title28}：</strong>
                  <span>
                    {this.state.result.parkingFeeInfo ? this.state.result.parkingFeeInfo : "--"}
                  </span>
                </li>

                <li className="stationName">
                  <strong>{this.internationalization.title29}：</strong>
                  <span>
                    {this.state.result.isPlaceHoldFree ? this.state.result.isPlaceHoldFree : "--"}
                  </span>
                </li>
                <li className="stationName">
                  <strong>{this.internationalization.title30}：</strong>
                  <span>{this.state.result.noticInfo ? this.state.result.noticInfo : "--"}</span>
                </li>
                <li className="stationName">
                  <strong>{this.internationalization.title31}：</strong>
                  <span>
                    {this.state.result.enableRoamingStr ? this.state.result.enableRoamingStr : "--"}
                  </span>
                </li>
                <li className="stationName">
                  <strong>{this.internationalization.title32}：</strong>
                  <span>{this.state.result.statusInfo ? this.state.result.statusInfo : "--"}</span>
                </li>
                <li className="stationName">
                  <strong>{this.internationalization.title33}：</strong>
                  <span>
                    {this.state.result.equipmentOwnerName
                      ? this.state.result.equipmentOwnerName
                      : "--"}
                  </span>
                </li>
                <li className="stationName">
                  <strong>{this.internationalization.title34}：</strong>
                  <span>
                    {this.state.result.equipmentOperatorName
                      ? this.state.result.equipmentOperatorName
                      : "--"}
                  </span>
                </li>
                <li className="stationName">
                  <strong>{this.internationalization.title35}：</strong>
                  <span>{this.state.result.startTime ? this.state.result.startTime : "--"}</span>
                </li>
                <li className="stationName">
                  <strong>{this.internationalization.title44}：</strong>
                  <span>
                    {this.state.result.firstStartTime ? this.state.result.firstStartTime : "--"}
                  </span>
                </li>

                {/* <li className="stationName">
                  <strong>{this.internationalization.title36}：</strong>
                  <span>{this.state.result.startTime ? this.state.result.startTime : "--"}</span>
                </li> */}
                {/* <li className="stationName">
                  <strong>{this.internationalization.title37}：</strong>
                  <span>
                    {this.state.result.frameWork && this.state.result.updateType
                      ? `${this.state.result.updateType}-${this.state.result.frameWork}`
                      : "--"}
                  </span>
                  <a onClick={this.handleStubframeWorkClick}>查看详情</a>
                </li> */}

                <li className="stationName">
                  <strong>{this.internationalization.title38}：</strong>
                  <span>{this.state.result.dcSubCnt ? this.state.result.dcSubCnt : "--"}</span>
                </li>
                <li className="stationName">
                  <strong>{this.internationalization.title39}：</strong>
                  <span>{this.state.result.acStubCnt ? this.state.result.acStubCnt : "--"}</span>
                </li>
                <li className="stationName">
                  <strong>{this.internationalization.title40}：</strong>
                  <span>
                    {this.state.result.totalFeeInfo
                      ? this.formatterPrice(JSON.parse(this.state.result.totalFeeInfo))
                      : "--"}
                  </span>
                </li>
                <li className="stationName">
                  <strong>{this.internationalization.title41}：</strong>
                  <span>
                    {this.state.result.equipmentOperatorName
                      ? this.state.result.equipmentOperatorName
                      : "--"}
                  </span>
                </li>
                <li className="stationName">
                  <strong>{this.internationalization.title45}：</strong>
                  <span>
                    {this.state.result.dischargeFee ? this.state.result.dischargeFee : "--"}
                  </span>
                </li>
                <li className="stationName">
                  <strong>{this.internationalization.title43}：</strong>
                  <span>
                    {this.state.result.companyList ? this.state.result.companyList : "--"}
                  </span>
                </li>
              </ul>
            </div>
            <div className="page-info-item">
              <h3>
                <span>{this.internationalization.title18}</span>
              </h3>
              <ul>
                <li className="stationName">
                  <strong>{this.internationalization.title42}：</strong>

                  <a onClick={this.handleStubframeWorkClick}>查看</a>
                </li>
                {/* <li className={'stationName'}>
                                    <strong>固件型号：</strong>
                                    <span>{this.state.result.frameWork}</span>
                                </li> */}
              </ul>
            </div>
            {this.state.result.type === 0 && this.state.result.equipmentOwnerId === "MA1YDN61X" ? (
              <div className="page-info-item">
                <h3>
                  <span>运维增值服务信息</span>
                </h3>
                <ul>
                  <li className="stationName">
                    <strong>是否签订运维增值服务：</strong>
                    <span>{this.state.result.signedFlag === 1 ? "是" : "否"}</span>
                  </li>
                  {this.state.result.signedFlag === 1 ? (
                    <li className="stationName">
                      <strong>签订合同有效期：</strong>
                      <span>
                        {this.state.result.addServiceTimeStart &&
                        this.state.result.addServiceTimeEnd
                          ? `${this.state.result.addServiceTimeStart}-${this.state.result.addServiceTimeEnd}`
                          : "--"}
                      </span>
                    </li>
                  ) : null}
                  {this.state.result.signedFlag === 1 ? (
                    <li className="stationName">
                      <strong>增值服务内容：</strong>
                      <span>
                        {this.state.result.addServiceContent
                          ? this.state.result.addServiceContent
                          : "--"}
                      </span>
                    </li>
                  ) : null}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <Modal
          title="充电记录"
          visible={this.state.seeframeWorkVisible}
          footer={null}
          destroyOnClose
          width="1100px"
          onCancel={() => {
            this.modalVisibleAction("seeframeWorkVisible", false);
          }}>
          <ChargeOrder3Day stubId={this.stubIdData} />
        </Modal>
        <Modal
          width={600}
          title="历史记录"
          visible={this.state.dbmHistoryVisible}
          footer={null}
          destroyOnClose
          onCancel={() => {
            this.modalVisibleAction("dbmHistoryVisible", false);
          }}>
          <DbmHistory stubId={this.stubIdData} />
        </Modal>
        <Modal
          title="电损系数配置"
          visible={this.state.edited}
          destroyOnClose
          onCancel={() => this.setState({ edited: false })}
          onOk={this.handleSubmitElEdit}>
          <ElectricalLossEdit info={this.state.result} ref={(ref) => (this.elRef = ref)} />
        </Modal>
      </Spin>
    );
  }
}

export default injectIntl(StubGroupDetailInfo);
StubGroupDetailInfo.propTypes = {
  // onAdd: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/stubGroupDetailInfo.js